// 会话TOKEN：保存、清除
export const SAVE_TOKEN = 'saveToken'
export const CLEAR_TOKEN = 'clearToken'
export const SAVE_MP_TOKEN = 'saveMpToken'  // 微信小程序TOKEN

// 保存活动ID、详情
export const SAVE_ID = 'saveId'
export const SAVE_DETAIL = 'saveDetail'

// 保存路由
export const SAVE_ROUTE = 'saveRuote'

// 投票对象：选择、清空
export const SELECT_PLAYER = 'selectPlayer'
export const CLEAR_PLAYER = 'clearPlayer'

// 微信提示
export const WECHAT_TIP = 'wechatTip'

// 验证码显示
export const VERIFY_CODE = 'verifyCode'

// 投票（后）广告显示
export const VOTE_AD = 'voteAd'

// 倒计时结束
export const COUNTDOWN_END = 'countdownEnd'

// 关闭底部广告
export const FOOTER_END = 'footerEnd'

// 更新提示
export const UPDATE_TIP = 'updateTip'

// 显示海报
export const SHOW_POSTER = 'showPoster'

// 显示栏目
export const SHOW_MEAU = 'showMeau'

// 显示多选
export const SHOW_SELECT = 'showSelect'

//清除分组选手
export const CLEAR_GROUP_PLAYER = 'clearGROUPPlayer'

//保存选择分组ID
export const SAVE_GROUP_ID = 'saveGroupId'

//保存分组ID
export const SAVE_REAL_GROUP_ID = 'saveRealGroupId'

//保存分组个数
export const SAVE_GROUP_DATA = 'saveGroupDATA'

//保存投票规则
export const SAVE_VOTE_RULE = 'saveVoteRule'

// 显示栏目
export const SHOW_GROUP_SUB_VIEW = 'showGroupSubView'
 //投票规则展开或折叠
export const EXPAND_VOTE_RULE = 'expandVoteRule'

export const SET_LAST_VOTE_PLAYER_ID = 'set_last_vote_player_id'
export const SET_LAST_VOTE_PLAYER_IDS = 'set_last_vote_player_ids'

